import Icon from '../../components/Icon.vue'

Icon.register({"regular/sad-tear":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM256 304C242.8 304 232 314.8 232 328S242.8 352 256 352C279.8 352 302.3 362.5 317.6 380.8 325.7 390.6 340.8 392.7 351.4 383.9 361.6 375.4 363 360.3 354.5 350.1 330 320.8 294.1 304 256 304zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176zM162.4 274.8C151 290.1 126 325.4 126 342.9 126 365.6 144.8 384 168 384S210 365.6 210 342.9C210 325.4 185 290.1 173.6 274.8 170.8 271.1 165.2 271.1 162.4 274.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/sad-tear.js
// module id = null
// module chunks = 